import { render } from "./TakeHomeCriteriaForm.vue?vue&type=template&id=492c2838&scoped=true"
import script from "./TakeHomeCriteriaForm.vue?vue&type=script&lang=js"
export * from "./TakeHomeCriteriaForm.vue?vue&type=script&lang=js"

import "./TakeHomeCriteriaForm.vue?vue&type=style&index=0&id=492c2838&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-492c2838"]])

export default __exports__